import App from './App'
import React from 'react'
import ReactDOM from 'react-dom/client'
import {
  Provider,
  ReactReduxContextValue,
  createDispatchHook,
  createSelectorHook,
  TypedUseSelectorHook,
} from 'react-redux'
import { AppDispatch, RootState, store } from './store'

const root = ReactDOM.createRoot(document.getElementById('root')!)

export const VerandaContext = React.createContext<ReactReduxContextValue>(
  null as any
)
export const useVerandaDispatch: () => AppDispatch =
  createDispatchHook(VerandaContext)

export const useVerandaSelector: TypedUseSelectorHook<RootState> =
  createSelectorHook(VerandaContext)

root.render(
  <Provider store={store} context={VerandaContext}>
    <App />
  </Provider>
)
